/**
 * Created by anair on 02/26/17.
 */

import React from 'react';
import {render} from 'react-dom';
import {TRIAL_PORTAL_HOME} from "../js/constants";

class PostWalkthroughExitPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {show : true};
  }

  hide = () => {
    if (this.props.walkThroughError && this.props.walkThroughError === 'true') {
        if (this.props && this.props.hide) {
            this.props.hide(); // use in trial page
        } else {
            $(this.props.walkthrough).hide(); // use in integration page
        }
    } else {
      this.props.walkthrough.innerHTML = "";
    }
  }

  getDescriptionText = () => {
    const content = this.props.content;
    return this.props.walkThroughError ? content.error : content.description;
  }

  getButtons() {
    const buttons = this.props.content.buttons;
    if (this.props.walkThroughError && this.props.walkThroughError === 'true') {
      return (
        <div className="walkthrough-mdl-footer">
          <div className="walkthrough-continue-button" onClick={this.hide}>{buttons.cancel}</div>
        </div>
      );
    } else {
      return (
        <div className="walkthrough-mdl-footer">
          <button onClick={() => location.reload(true)} className="try-button">{buttons.cancel}</button>
          <a href={TRIAL_PORTAL_HOME}>
            <div className="explore-another-solution-button">{buttons.explore}</div>
          </a>
          <div className="cancel-button" onClick={this.hide}>{buttons.start}</div>
        </div>
      );
    }
  }

  render() {
    return (
        <div className="walkthrough-mdl-container">
              <div className="walkthrough-mdl">
                <div className="walkthrough-mdl-header exit">
                  <div className="text-style">{this.props.selectedUseCase.title}</div>
                </div>
                <div className="walkthrough-mdl-header-body-divider">
                </div>

                <div className="walkthrough-mdl-body">
                    <div className="walkthrough-mdl-body-text-style">
                        <div className="header-text-style-exit">
                          {this.getDescriptionText()}
                        </div>
                    </div>
                </div>
                {this.getButtons()}
            </div>
        </div>

    );
   }
}

export default PostWalkthroughExitPage;
